import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_GifMaker = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/gif-maker',
			name: 'GIF Maker Online — Create & Convert GIFs Instantly by Lift',
			description:
				'Create GIFs online — upload your video or image file and Lift converts it to GIF in seconds. Supports MP4, MOV, AVI, WEBM, and more. Try Lift now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/gif-maker#product' },
				{ '@id': 'https://liftapp.ai/gif-maker#howto' },
				{ '@id': 'https://liftapp.ai/gif-maker#faq' },
				{ '@id': 'https://liftapp.ai/gif-maker#why-lift' },
				{ '@id': 'https://liftapp.ai/gif-maker#explore-tools' },
				{ '@id': 'https://liftapp.ai/gif-maker#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/gif-maker#product',
			name: 'GIF Maker Online',
			description:
				'Convert video files to GIF and dozens of other formats. Upload your file, choose GIF as output, and download the result in seconds.',
			url: 'https://liftapp.ai/gif-maker',
			fileFormat: [
				'image/gif',
				'video/mp4',
				'video/quicktime',
				'video/x-msvideo',
				'video/webm',
				'video/x-matroska',
			],
			memoryRequirements: 'Max file size: 2GB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/gif-maker#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your File',
					text: 'Drop in any supported video format — MP4, MOV, AVI, MKV, WEBM, FLV, and more.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose GIF as Output',
					text: 'Select GIF from dozens of output formats — or choose any other video or audio format you need.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Lift Creates Your GIF',
					text: 'Lift processes your file with high-fidelity encoding, preserving quality and animation smoothness.',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download the Result',
					text: 'Your GIF is ready instantly — download it for sharing, messaging, social media, or embedding.',
				},
			],
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/gif-maker#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is the Lift GIF Maker?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift GIF Maker is an online tool that converts video files to GIF and dozens of other formats in seconds. Upload your source file, choose an output format, and download the result.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does the Lift GIF Maker work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your video file in any supported format, select GIF as the output format, and Lift processes the file. Your animated GIF is ready to download in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'How long does GIF conversion take?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Most conversions complete in seconds. Processing time depends on file size and length, but Lift is optimized to deliver converted results as fast as possible.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will converting to GIF affect quality?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift uses high-fidelity encoding to preserve animation smoothness and visual quality during GIF conversion.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift prioritizes your privacy — all files are processed securely and are not stored or shared after conversion. Your converted result is available only to you.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/gif-maker#why-lift',
			name: "Why Lift's GIF Maker stands out",
			description:
				'High-quality results, intelligent rendering, cross-platform support, and budget-friendly pricing — Lift delivers professional-grade GIF creation.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers smooth, high-quality GIFs every time.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the conversion to the file type for optimal GIF output.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description:
						'Available on iOS, Android, and Web for seamless access.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly software with an affordable and intuitive tool.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl: 'https://liftapp.ai/images/gif-maker/whyLift.webp',
				name: 'Lift GIF Maker delivering high-quality output',
				description: "Lift's online GIF maker in high resolution.",
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/gif-maker#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/gif-maker#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'GIF Maker',
					item: 'https://liftapp.ai/gif-maker',
				},
			],
		},
	],
};
